// EmailJS configuration constants (public credentials)
export const EMAILJS_CONFIG = {
    serviceId: "service_wpi18tg",
    templateId: "template_9wwddl8",
    publicKey: "qpGxmgmoRaim3csSz",
    toEmail: "ariadna.padilla@hewser.com",
};

export const BRAND = {
    name: "Hewser Personal Branding",
    whatsappRaw: "523332566694",
    whatsappDisplay: "+52 33 32 56 66 94",
    email: "ariadna.padilla@hewser.com",
    logo: "https://customer-assets.emergentagent.com/job_f537849a-f4f9-422b-99b0-12972cbc64d6/artifacts/ozxiufzq_logo.png",
};
